








import Vue from 'vue';
import store from '@/store';

import AdaptiveChartsLayout from '@/components/utils/AdaptiveChartsLayout.vue';

export default Vue.extend({
  components: {
    AdaptiveChartsLayout
  },

  props: {
    peerGroupId: Number
  },

  computed: {
    organizationId(): number {
      return store.state.org.basic.organizationId;
    },

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    peerGroupProfileComponent(): any {
      return {
        component: 'organization-peer-group-profile',
        props: {
          peerGroupId: this.peerGroupId
        },
        tabName: 'Roster & COGS'
      };
    }
  }
});
